import script from "./UpCarInent.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpCarInent.vue?vue&type=script&lang=ts&setup=true"

import "./UpCarInent.vue?vue&type=style&index=0&id=0ad0464c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad0464c"]])

export default __exports__